module.exports = __webpack_public_path__ + "static/img/malte-wingen-PDX_a_82obo-unsplash_thumb.0d8c42c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/malte-wingen-PDX_a_82obo-unsplash_thumb.png
// module id = fdz9
// module chunks = 4